export const environment = {
  production: false,
  apiUrl: 'https://s-secure.taxiid.nl/v2/corporate',
  loginByIp: true,
  loginByIpSalt: 'JohnLennon',
  loginByIpCompany: 'OTQ4NQ==',
  translationProjectId: '5ddfa0d8a22b8cc7a35680c5',
  googleApiKey: 'AIzaSyDhvU9dn3J_IIXfCk6MLyD0Qc06v0JCKl4',
};
